import { Text } from "@solomon-labs/design/components/ui";
import React from "react";

export interface TrancheSummaryRowProps {
    /** Left cluster — the threshold label (e.g. "≥ 10,000 USDv", "≥ 30 days"). */
    label: React.ReactNode;
    /** Right cluster — the reward value (e.g. "2x Multiplier"). Rendered in the
     *  numeric family. */
    value: React.ReactNode;
}

/**
 * TrancheSummaryRow — ONE read-only tranche row: a threshold label on the
 * left, a reward value on the right. The read twin of the editable
 * `TrancheInput`, used in `PolicyRow`'s expanded accordion.
 *
 * Generic Component: knows no Solomon/YaaS entity. The caller formats the
 * threshold + multiplier into the `label` / `value` slots.
 */
export function TrancheSummaryRow({
    label,
    value
}: TrancheSummaryRowProps): React.ReactElement {
    return (
        <div className="flex items-center justify-between gap-4">
            <Text
                variant="fine-print"
                render={<span />}
                className="text-foreground-muted"
            >
                {label}
            </Text>
            <Text
                variant="fine-print"
                render={<span />}
                className="text-foreground-base font-numeric"
            >
                {value}
            </Text>
        </div>
    );
}
